// Aviso de "el saldo de este socio ha cambiado", para que todas las pantallas
// que lo pintan se enteren al momento (plan CRUO 24-ago, §E).
//
// Hoy la propagación es artesanal: un callback `onBalanceChanged` cableado a
// mano en tres pantallas, mientras el saldo se pinta en ~20 sitios. Cualquier
// pantalla no cableada se queda con el número viejo — y la ficha abierta desde
// Sala ni siquiera tiene el callback.
//
// El patrón es el de carritosBus (quien escribe emite, quien pinta escucha, sin
// conocerse), con el canal ensanchado a BroadcastChannel porque el criterio de
// aceptación del plan es explícito: "con Sala abierta en OTRA PESTAÑA → el saldo
// cambia solo". Un evento de window no sale de su pestaña; el canal sí. El
// evento local se emite además siempre (mismo tick, sin esperar al canal), y si
// el navegador no tiene BroadcastChannel se queda solo lo local — peor es nada.
//
// Los sondeos y refrescos existentes se quedan como red de seguridad por si
// algún camino nuevo se olvida de avisar.
const EVENTO = 'wa:saldo-cambiado';
const CANAL = 'wa-saldo';

// Identidad de ESTE documento. BroadcastChannel no entrega al objeto que emitió,
// pero sí a los DEMÁS objetos del mismo documento — y los suscriptores tienen el
// suyo. Así que cada aviso llegaba dos veces a la misma pestaña: una por el
// evento de window y otra por el canal, y cada handler corría por duplicado (dos
// re-render de la lista de sala por cobro). Se marca el origen y el suscriptor
// descarta lo suyo, que ya le llegó por la vía local.
const ESTE_DOCUMENTO =
  (typeof crypto !== 'undefined' && crypto.randomUUID)
    ? crypto.randomUUID()
    : `doc-${Math.random().toString(36).slice(2)}-${Date.now()}`;

function canal() {
  try {
    return typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel(CANAL) : null;
  } catch {
    return null;
  }
}

export function avisarSaldoCambiado(userId, newBalance) {
  // `Number(null) === 0`: un null colado se convertiría en un 0 € falso y toda
  // pantalla suscrita lo pintaría como saldo real. Se corta ANTES de convertir
  // (la misma trampa que ya cazó AddCashModal en su día).
  if (typeof window === 'undefined' || userId == null || newBalance == null) return;
  const bal = Number(newBalance);
  if (!Number.isFinite(bal)) return;
  const detail = { userId: String(userId), newBalance: bal };
  window.dispatchEvent(new CustomEvent(EVENTO, { detail }));
  const bc = canal();
  if (bc) {
    try {
      bc.postMessage({ ...detail, emisor: ESTE_DOCUMENTO });
    } finally {
      bc.close();
    }
  }
}

/** Suscribe `handler({userId, newBalance})`. Devuelve la función de limpieza. */
export function alCambiarSaldo(handler) {
  if (typeof window === 'undefined') return () => {};
  const local = (e) => handler(e.detail);
  window.addEventListener(EVENTO, local);
  const bc = canal();
  const remoto = (e) => {
    // De esta misma pestaña ya llegó por el evento local: se descarta.
    if (e?.data?.emisor === ESTE_DOCUMENTO) return;
    handler(e.data);
  };
  if (bc) bc.addEventListener('message', remoto);
  return () => {
    window.removeEventListener(EVENTO, local);
    if (bc) {
      bc.removeEventListener('message', remoto);
      bc.close();
    }
  };
}
